/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice } from '@reduxjs/toolkit';
import {
  UsersListState,
  UsersListFetchAction,
  UsersListFetchSuccessAction,
  UsersListFetchInstitutionsSuccessAction,
  UsersListDoUserAction,
  UsersListDoUserSuccessAction,
} from './usersList.types';
import { createSelector, createSliceHook, makeActionCreator } from '../helpers';

const initialState: UsersListState = {
  loading: false,
  error: undefined,
  institutions: [],
  userActionLoading: false,
  loadingInstitutions: false,
  data: undefined,
};

const { actResolve, actReject, actReq, act, actEmpty } =
  makeActionCreator<UsersListState>();

export const usersListSlice = createSlice({
  name: 'usersList',
  initialState,
  reducers: {
    fetchUsersList: actReq<UsersListFetchAction['payload']>(),
    fetchUsersListSuccess: actResolve<UsersListFetchSuccessAction['payload']>(),
    fetchUsersListFailure: actReject(),
    fetchUsersInstitution: actReq('loadingInstitutions'),
    fetchUsersInstitutionSuccess: actResolve<
      UsersListFetchInstitutionsSuccessAction['payload']
    >('institutions', 'loadingInstitutions'),
    fetchUsersInstitutionFailure: actReject('error', 'loadingInstitutions'),
    doUser: actEmpty<UsersListDoUserAction['payload']>(),
    doUserSuccess: actResolve<UsersListDoUserSuccessAction['payload']>(
      null,
      'userActionLoading'
    ),
    doUserFailure: actReject('error', 'userActionLoading'),
  },
});

export const {
  fetchUsersList,
  fetchUsersListSuccess,
  fetchUsersListFailure,
  doUser,
  doUserFailure,
  doUserSuccess,
  fetchUsersInstitution,
  fetchUsersInstitutionFailure,
  fetchUsersInstitutionSuccess,
} = usersListSlice.actions;

export const actions = {
  ...usersListSlice.actions,
};

export const useUsersListSlice = createSliceHook(usersListSlice.name, actions);

export const selectUsersListState = createSelector('usersList');
